module.exports = __webpack_public_path__ + "static/media/633.816096c4.webp";